import { render } from "./gcePersistentDisk.vue?vue&type=template&id=35c13684"
import script from "./gcePersistentDisk.vue?vue&type=script&lang=js"
export * from "./gcePersistentDisk.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__